import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import { CustomCard } from "../../../components/Card/CustomCard";

import { Fila1, Fila2 } from "../../../shared/ExtensionItems";

import icon0 from '../../../assets/img/icons/icono_mail.png';
import icon1 from '../../../assets/img/icons/icono_phone_white.png';

class Pensum extends Component {

    cursos = () => {
        let fila1 = () => {
            return (
                Fila1.map(option => (
                    <li key={option.id} className="fuente-monserrat" style={{padding:5}}> 
                        <i class="fa fa-circle" style={{color:"#1f2f6e", fontSize:8}}/> {option.nombre}
                    </li>
                )) 
            )
        }

        let fila2 = () => {
            return (
                Fila2.map(option => (
                    <li key={option.id} className="fuente-monserrat" style={{padding:5}}> 
                        <i class="fa fa-circle" style={{color:"#1f2f6e", fontSize:8}}/> {option.nombre}
                    </li>
                )) 
            )
        }

        return(
            <Row>
                <Col md={6}>{fila1()}</Col>
                <Col md={6}>{fila2()}</Col>
            </Row>
        )
    }

    contacto = () => (
        <React.Fragment>
            <div align="center" className="fuente-monserrat"><img className='extension-icons' src={ icon0 }/> Información general: info@iudlm.com</div>
            <div align="center" className="fuente-monserrat"><img className='extension-icons' src={ icon1 }/> Telf.: (0212) 9939139 | 9930983 | 9910710</div>
        </React.Fragment>
    )

    importante = () => (
        <p className="fuente-monserrat" style={{fontSize:14, paddingRight:25}} align="justify">
            Los cursos quedan sujetos a un mínimo de participantes, de no abrirse el curso de su elección, se le notificará los cambios correspondientes de fecha o los pasos para la devolución de su inversión.
        </p>
    )

    render() { 
        return (
            <div style = {{backgroundColor:"fafafa"}}>
                <Row className="padding-card">
                    <Col md={12} className="custom-mt-30">
                        <CustomCard
                            title={<div className="fuente-monserrat" align="center">Cursos y Talleres</div>}
                            color="#a80012"
                            content={<ul>{this.cursos()}</ul>}
                        />
                    </Col>
                    <Col md={6}>
                        <CustomCard
                            height = {200}
                            title={<div className="fuente-monserrat" align="center">Contacto</div>}
                            color="#a80012"
                            content={<ul>{this.contacto()}</ul>}
                        />
                    </Col>
                    <Col md={6}>
                        <CustomCard
                            height = {200}
                            title={<div className="fuente-monserrat" align="center">Nota Importante</div>}
                            color="#a80012"
                            content={<ul>{this.importante()}</ul>}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default Pensum;


// WEBPACK FOOTER //
// ./src/site/Componentes/Extension/Content.jsx